module.exports = __webpack_public_path__ + "static/media/leftbypass.0c197043.png";